function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import TileLayer from 'ember-leaflet/components/tile-layer';

/**
 * Used to display WMS services as tile layers on the map.
 *
 * @class WmsTileLayer
 * @extends TileLayer
 */
export default class WmsTileLayer extends TileLayer {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "leafletOptions", [...this.leafletOptions,
    /**
     * (required) Comma-separated list of WMS layers to show.
     * Defaults to `''`.
     *
     * @argument layers
     * @type {String}
     */
    'layers',
    /**
     * Comma-separated list of WMS styles.
     * Defaults to `''`.
     *
     * @argument styles
     * @type {String}
     */
    'styles',
    /**
     * WMS image format (use 'image/png' for layers with transparency).
     * Defaults to `'image/jpeg'`.
     *
     * @argument format
     * @type {String}
     */
    'format',
    /**
     * If true, the WMS service will return images with transparency.
     * Defaults to `false`.
     *
     * @argument transparent
     * @type {Boolean}
     */
    'transparent',
    /**
     * Version of the WMS service to use
     * Defaults to `'1.1.1'`.
     *
     * @argument version
     * @type {String}
     */
    'version',
    /**
     * Coordinate Reference System to use for the WMS requests,
     * defaults to map CRS. Don't change this if you're not sure what it means.
     * Defaults to `null`.
     *
     * @argument crs
     * @type {CRS}
     */
    'crs',
    /**
     * If true, WMS request parameter keys will be uppercase.
     * Defaults to `false`.
     *
     * @argument uppercase
     * @type {Boolean}
     */
    'uppercase']);
  }
  createLayer() {
    return this.L.tileLayer.wms(...this.requiredOptions, this.options);
  }
}